/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-04-16 21:28:34
 * description  : 图片icon 单选组件
 * author       : zhizhan
 */
import "./index.less";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Utils, { get, set } from "../../utils";
import { Button } from "antd";
import { YxComponent, Connection } from "../YxComponent";
import { isEqual, merge } from "lodash";

@Connection()
class IconRadio extends YxComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value, //扩展icon组件默认参数
    };
  }
  componentWillReceiveProps(nextProps) {
    const { props } = this;
    if (!isEqual(nextProps.value, props.value)) {
      this.setState({ value: nextProps.value });
    }
  }
  iconClick = (value, event) => {
    const setFieldsValue = get(this, "props.form.setFieldsValue", () => {});
    setFieldsValue({ [get(this, "props.id")]: value }); //解决antd getFieldsValue获取值延迟
    get(this, "props.change", () => {})(value);
    this.setState({ value: value });
  };
  iconList = () => {
    const { value } = this.state;
    let tmpProps = { ...this.props };
    return (
      <div className="radio_box">
        {tmpProps.data.map((val) => {
          if (val.icon) {
            return (
              <Button
                key={val.value}
                onClick={() => {
                  this.iconClick(val.value, tmpProps);
                }}
                className={val.value == value ? "yx_yxRadio_icon_selected" : ""}
                value={val.key || val.value}
                type=""
                icon={val.icon}
                size="large"
              ></Button>
            );
          }
          if (val.src) {
            return (
              <div
                key={val.value}
                onClick={(e) => {
                  this.iconClick(val.value, e);
                }}
                className={
                  val.value == value
                    ? "yx_yxRadio_icon_selected radioImg"
                    : "radioImg"
                }
              >
                <img src={val.value == value ? val.srcSelected : val.src}></img>
              </div>
            );
          }
        })}
      </div>
    );
  };
  render() {
    return (
      <div className={`yx_yxRadio_size_icon yx_yxRadio_icon`}>
        {this.iconList()}
      </div>
    );
  }
}
IconRadio.propTypes = {
  data: PropTypes.array.isRequired /* 渲染单选按钮 */,
  value: PropTypes.string /* 当前选中项 */,
  change: PropTypes.func /* 点击更改回调 */,
};
IconRadio.defaultProps = {
  change: () => {},
};
export default IconRadio;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IconRadio.js